import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/webapp-shared';

/**
 * @deprecated use $IsMobileUser
 */
export function useBasicCondition(): boolean {
  const { isBot, isMobile, isInApp } = useAtomValue($UserAgent);

  return !isBot && isMobile && !isInApp;
}
